import { Box, SelectChangeEvent } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../../../components/common/BriaButton/BriaButton.tsx";
import { DropDownItem } from "../../../../../../../components/common/BriaDropDown/BriaDropDown.tsx";
import InputLayout from "../../../../../../../layout/InputLayout/InputLayout";
import NewTgDropdown from "../../../../Dropdown/NewTgDropdown.tsx";
import { TgModel } from "../../../../store/tg-model-store.tsx";
import styles from "./CompareModels.module.scss";

interface CompareModelProps {
	model: TgModel | undefined;
	index: number;
	onRemove: () => void;
	onModelChange: (model: TgModel | undefined) => void;
}

const CompareModel = ({ model, index, onRemove, onModelChange }: CompareModelProps) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.viewer.evaluation.config.compareModels" });

	const handleModelChange = (_e: SelectChangeEvent<string>, selectedItem: DropDownItem<string, TgModel>) => {
		const { extraData } = selectedItem;
		onModelChange(extraData);
	};

	return (
		<Box className={styles.modelContainer}>
			<InputLayout
				label={`Compared model ${index + 1}`}
				actionButton={
					<BriaButton buttonType="textSmall" className={styles.removeButton} onClick={onRemove}>
						{t("removeButton.label")}
					</BriaButton>
				}
			>
				<NewTgDropdown
					value={model?.id?.toString() || ""}
					onChange={handleModelChange}
					showCheckpoints
					placeholder={t("placeholder")}
					hideTrainButton
				/>
			</InputLayout>
		</Box>
	);
};

export default observer(CompareModel);
